import { render, staticRenderFns } from "./Koutu_pay.vue?vue&type=template&id=625219d9&scoped=true"
import script from "./Koutu_pay.vue?vue&type=script&lang=js"
export * from "./Koutu_pay.vue?vue&type=script&lang=js"
import style0 from "./Koutu_pay.vue?vue&type=style&index=0&id=625219d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625219d9",
  null
  
)

export default component.exports